import { render } from "./ConfirmRedeemModal.vue?vue&type=template&id=34de8a43&scoped=true"
import script from "./ConfirmRedeemModal.vue?vue&type=script&lang=js"
export * from "./ConfirmRedeemModal.vue?vue&type=script&lang=js"

import "./ConfirmRedeemModal.vue?vue&type=style&index=0&id=34de8a43&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34de8a43"]])

export default __exports__